import { FeaturedContent } from './featured-content';
import { navigate, subscribe } from './featured-content/featured-content-service';
import { subNavigationItem } from './featured-content/featured-content-templates';

const selectors = {
  mainNavigation: '.c-featured-navigation',
  subNavigation: '.c-featured-navigation-sub-categories',
  subNavigationList: '.c-featured-navigation-sub__list',
  mainWrapper: '.c-featured-content',
  backButton: '.c-featured-content__header .c-featured-content__back',
};
class FeaturedNavigation {
  constructor($el) {
    this.itemsContainer = $el
    this.isSubNavigationInstance = $el.classList.contains(selectors.subNavigation.replace('.', ''));

    const mainWrapper = $el.closest(selectors.mainWrapper);
    this.backButton = mainWrapper ? mainWrapper.querySelector(selectors.backButton) : undefined;

    if(this.isSubNavigationInstance) {
      this.subNavigationListContainer = $el.querySelector(`${selectors.subNavigation} ${selectors.subNavigationList}`);

      subscribe((data, { type }) => {
        if (type !== 'category') return
        this.populateSubNavigation(data)
      });

      FeaturedContent.backButton.addEventListener('click', this.clickHandler)
    }


    if ($el.dataset.contentCentrePage === 'true') {
      this.bindEvents()
    }
  }

  populateSubNavigation({ Id, MainCategory }){
    const { Categories = [] } = MainCategory || { };
    const templateContainer = document.createElement('template');
    templateContainer.innerHTML = Categories
      .map((Category) => subNavigationItem({...Category, Active: Category.Id === Id }))
      .join('');

    this.itemsContainer.setAttribute('aria-hidden', String(Categories.length === 0));
    this.backButton.setAttribute('aria-hidden', String(Categories.length === 0));

    this.subNavigationListContainer.replaceChildren(templateContainer.content)
    this.bindEvents()
  }

  clickHandler(e) {
    const pageSize = FeaturedContent.pageSize();
    FeaturedContent.hide();

    navigate({
      id: e.currentTarget.dataset.tag || e.currentTarget.dataset.id || null,
      page: 1,
      pageSize,
      type: 'category',
    });
    e.preventDefault();
  };

  bindEvents() {
    this.itemsContainer
      .querySelectorAll('a[data-id]')
      .forEach(item => item.addEventListener('click', this.clickHandler))
  }
}

[...document.querySelectorAll(`${selectors.mainNavigation}, ${selectors.subNavigation}`)].forEach(
  $el => new FeaturedNavigation($el)
);
